import React from 'react'
import PropTypes from 'prop-types'
import { Toast } from '@chilecompra/react-kit/components'
import { ERRORS_DICTIONARY } from '../../config/settings/constants'
import { Grid } from './AttachFiles.styles'
import { Link } from './Errors.styles'

/**
 * The Errors's component.
 */
const Errors = props => {
  const { errors, onCleanErrors, maxUtm = 100, maximumAmountFormater, providerFileUrl = null, severity } = props

  return (
    errors &&
    errors.length > 0 && (
      <Grid container style={{ width: '100%' }} margin="16px 0 24px">
        <Grid item xs={12}>
          {errors.map(error => (
            <Toast
              key={error.code}
              margin="4px 0"
              onClose={onCleanErrors}
              severity={severity}
              title={ERRORS_DICTIONARY[error.description]?.title || ERRORS_DICTIONARY.DEFAULT_ERROR.title}
            >
              <br />
              {maxUtm > 0
                ? ERRORS_DICTIONARY[error.description]?.message
                    .replace('ReplaceMaxUtm', maxUtm)
                    .replace('maximumAmountFormater', maximumAmountFormater)
                : ERRORS_DICTIONARY[error.description]?.message || ERRORS_DICTIONARY.DEFAULT_ERROR.message}
              {providerFileUrl && (
                <Link href={providerFileUrl} target="_blank" rel="noopener noreferrer">
                  Revisa el estado de tu empresa
                </Link>
              )}
            </Toast>
          ))}
        </Grid>
      </Grid>
    )
  )
}

Errors.defaultProps = {
  errors: [],
  onCleanErrors: undefined,
  openDialog: false,
  maxUtm: 0,
  maximumAmountFormater: 0,
  providerFileUrl: '',
  severity: 'error'
}

Errors.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    })
  ),
  onCleanErrors: PropTypes.func,
  maxUtm: PropTypes.number,
  maximumAmountFormater: PropTypes.number,
  providerFileUrl: PropTypes.string,
  severity: PropTypes.string
}

export default Errors
